<template>
    <a :href="changeCartStatus ? 'javascript:void(0)' : data.detail_url"
       class="product js-ga-event"
       :class="{ disableHover: changeCartStatus }"
       :data-page-area="dataPageArea"
       data-type="product"
       data-name="product-name"
       :data-text="data.name"
       data-action="href"
       :data-destination-url="changeCartStatus ? 'javascript:' : data.detail_url"
    >

        <BadgeHolder
             :badges="data.badges"
             :discount_price="data.discount_price"
             :main_price="data.main_price"
             :default_price="data.default_price"
             :stock="data.available"
             :has_variations="data.has_variations"
             :variation_values="data.variation_values">
        </BadgeHolder>

        <figure>
            <template v-if="data.image_url">
                <img :src="data.image_url" :alt="data.name">
            </template>
            <template v-else>
                <img :src="data.defaultImage" :alt="data.name">
            </template>
        </figure>
        <h4>{{ data.name }}</h4>
        <p class="excerpt">
          {{ data.tag_text }}
        </p>
        <div class="description" v-html="data.preview_text"></div>
        <span class="bottom">

            <span class="price">
                <template v-if="data.has_variations">
                    <span class="main">
                        od {{ parseFloat(data.price).toFixed(2) }} {{ currency }}
                    </span>
                </template>
                <template v-else>
                   <span class="old" v-if="data.default_price && parseFloat(data.price) < parseFloat(data.default_price)">
                        {{ parseFloat(data.default_price).toFixed(2) }} {{ currency }}
                    </span>
                    <span class="main">
                        {{ parseFloat(data.price).toFixed(2) }} {{ currency }}
                    </span>
                </template>
            </span>

            <template v-if="discounted == 1">
                <AddToCart
                       :product-id-p="data.id"
                       :btn-text="btnText"
                       :btn-text-in-cart="btnTextInCart"
                       :btn-text-remove="btnTextRemove"
                       :should-change-status="changeCartStatus"
                       :discounted="1"
                       :discount-percentage="discountPercentage"
                       :in_cart="data.in_cart"
                       :gtm-data-p="gtmData"
                />
            </template>
            <template v-else>
                <template v-if="changeCartStatus">
                    <AddToCart :product-id-p="data.id"
                               :btn-text="btnText"
                               :btn-text-in-cart="btnTextInCart"
                               :btn-text-remove="btnTextRemove"
                               :should-change-status="changeCartStatus"
                               :gtm-data-p="gtmData"
                    />
                </template>
                <template v-else-if="shouldAddToCart">
                    <AddToCart :product-id-p="data.id"
                               :btn-text="btnText"
                               :btn-text-in-cart="btnTextInCart"
                               :btn-text-remove="btnTextRemove"
                               :gtm-data-p="gtmData"

                    />
                </template>
                <template v-else>
                    <span class="button add-to-cart">
                        {{ btnText }}
                        <img src="/img/icons/cart.svg" v-svg-inline>
                    </span>
                </template>
            </template>
        </span>
    </a>
</template>

<script>
import { inject, onMounted, reactive, toRefs } from 'vue'
import { getCategoryByPosition } from '../../../functions/helpers'

import AddToCart from '../../buttons/AddToCart'
import BadgeHolder from "./BadgeHolder";

export default {

    props: [
        'data',
        'btnText',
        'btnTextInCart',
        'btnTextRemove',
        'changeCartStatus',
        'discounted',
        'discountPercentage',
        'dataPageArea',
        'shouldAddToCart'
    ],

    components: {
        AddToCart,
        BadgeHolder,
    },

    setup(props) {

        const constants  = inject('constants')

        const state = reactive({
            gtmData: {
                currency: constants.currency,
                value: props.data.price,
                items: [{
                    item_id: props.data.id,
                    item_name: props.data.name,
                    affiliation: 'Eshop',
                    coupon: '',
                    discount: '',
                    index: 1,
                    item_brand: props.data.brand ? props.data.brand.name : '',
                    item_category: props.data.front_categories_with_depth ? getCategoryByPosition(1, props.data.front_categories_with_depth) : null,
                    item_category2: props.data.front_categories_with_depth ? getCategoryByPosition(2, props.data.front_categories_with_depth) : null,
                    item_category3: props.data.front_categories_with_depth ? getCategoryByPosition(3, props.data.front_categories_with_depth) : null,
                    item_category4: props.data.front_categories_with_depth ? getCategoryByPosition(4, props.data.front_categories_with_depth) : null,
                    item_category5: props.data.front_categories_with_depth ? getCategoryByPosition(5, props.data.front_categories_with_depth) : null,
                    item_list_id: '',
                    item_list_name: '',
                    item_variant: '',
                    location_id: '',
                    price: props.data.price,
                    quantity: 1
                }]
            }
        })

        onMounted( () => {
            // console.log(props.data)
            // console.log(state.gtmData)

            if ( props.data.has_variations && props.data.variation_values ) {
                handleVariationDiscount()
            }
        })

        // todo
        function handleVariationDiscount() {
            props.data.variation_values.forEach( value => {
                if ( value.discount_price ) {
                    // state.hasDiscount = true
                    // state.discountPrice = value.discount_price
                }
            })
        }

        return {
            ...toRefs(constants),
            ...toRefs(state)
        }
    }
}
</script>
